import React from 'react';
import { Dialog, DialogContent, Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface PasswordChangeNotificationProps {
  open: boolean;
  onClose: () => void;
}

export const PasswordChangeNotification: React.FC<PasswordChangeNotificationProps> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    onClose();
    // URL 파라미터를 추가하여 Settings 페이지에서 비밀번호 변경 다이얼로그를 자동으로 열도록 함
    navigate('/settings?openPasswordDialog=true');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          border: '1px solid #c4c4c4',
          padding: '16px',
          minWidth: '320px',
          maxWidth: '400px',
        },
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          }}
        >
          {/* Warning Icon - Alter.svg */}
          <Box
            sx={{
              flexShrink: 0,
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src="/assets/images/Alter.svg"
              alt="Warning"
              style={{ width: '34px', height: '30px' }}
            />
          </Box>

          {/* Message Text */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: '40px',
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Noto Sans KR', sans-serif",
                fontSize: '13px',
                fontWeight: 400,
                lineHeight: '20px',
                color: '#0e0e0e',
                whiteSpace: 'pre-wrap',
              }}
            >
              임시 비밀번호로 로그인하셨습니다.{'\n'}
              보안을 위해 비밀번호를 변경해주세요.{'\n\n'}
              <Link
                onClick={handleLinkClick}
                sx={{
                  color: '#1976d2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': {
                    color: '#1565c0',
                  },
                }}
              >
                비밀번호 변경하러 가기
              </Link>
            </Typography>
          </Box>

          {/* Close Button - Close.svg */}
          <Box
            onClick={onClose}
            sx={{
              flexShrink: 0,
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.7,
              },
            }}
          >
            <img
              src="/assets/images/Close.svg"
              alt="Close"
              style={{ width: '24px', height: '24px' }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
